import Styled from 'styled-components';

import { IHeadlineProps } from '../../../Typography';

export const VerTaskHeadline = Styled.div<IHeadlineProps>`
  margin-right: 0.5em;
  display: inline-block;
  order: 2;
  font-weight: ${({ theme: { taskCard } }) => taskCard.fontWeightHeadline};
`;
